<div class="image-zoom-container">
  <img loading="lazy" class="main-image" [src]="mainImage" alt="mainImage" />
</div>
